import React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { scrollToTop } from '../hooks/useScrollToTop';

const ScrollToTopLink = ({ to, children, className, onClick, ...props }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    // Call the original onClick if provided
    if (onClick) {
      onClick(e);
    }

    // If it's a regular link (not external), handle scroll to top
    if (to && !to.startsWith('http') && !to.startsWith('mailto:') && !to.startsWith('tel:')) {
      // Prevent default behavior
      e.preventDefault();
      
      // Scroll to top immediately
      window.scrollTo(0, 0);
      
      // Navigate to the route
      navigate(to);
      
      // Additional scroll to top after navigation with multiple fallbacks
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 50);
      
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
      
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 200);
    }
  };

  // If it's an external link, use regular Link behavior
  if (to && (to.startsWith('http') || to.startsWith('mailto:') || to.startsWith('tel:'))) {
    return (
      <RouterLink to={to} className={className} {...props}>
        {children}
      </RouterLink>
    );
  }

  // For internal links, use button with navigation
  return (
    <button
      onClick={handleClick}
      className={className}
      {...props}
    >
      {children}
    </button>
  );
};

export default ScrollToTopLink;
